/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBillingWalletData
 */
export interface CreateBillingWalletData {
    /**
     * 
     * @type {number}
     * @memberof CreateBillingWalletData
     */
    billingWalletTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBillingWalletData
     */
    billingProductPriceId: number;
}

/**
 * Check if a given object implements the CreateBillingWalletData interface.
 */
export function instanceOfCreateBillingWalletData(value: object): value is CreateBillingWalletData {
    if (!('billingWalletTypeId' in value) || value['billingWalletTypeId'] === undefined) return false;
    if (!('billingProductPriceId' in value) || value['billingProductPriceId'] === undefined) return false;
    return true;
}

export function CreateBillingWalletDataFromJSON(json: any): CreateBillingWalletData {
    return CreateBillingWalletDataFromJSONTyped(json, false);
}

export function CreateBillingWalletDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBillingWalletData {
    if (json == null) {
        return json;
    }
    return {
        
        'billingWalletTypeId': json['billingWalletTypeId'],
        'billingProductPriceId': json['billingProductPriceId'],
    };
}

  export function CreateBillingWalletDataToJSON(json: any): CreateBillingWalletData {
      return CreateBillingWalletDataToJSONTyped(json, false);
  }

  export function CreateBillingWalletDataToJSONTyped(value?: CreateBillingWalletData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingWalletTypeId': value['billingWalletTypeId'],
        'billingProductPriceId': value['billingProductPriceId'],
    };
}

